import(/* webpackMode: "eager", webpackExports: ["BrowseClient"] */ "/home/fftu/cooking-videos/src/app/(main)/browse-client.tsx");
